//import '@vg-constellation/web/youtube-player'

import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

const TWENTY_FIVE_PERCENT = 25
const FIFTY_PERCENT = 50
const SEVENTY_FIVE_PERCENT = 75
const ONE_HUNDRED = 100
const VIDEO_START = 300
@Component({
  selector: 'vmf-constellation-video',
  templateUrl: './constellation-video.component.html',
  styleUrls: ['./constellation-video.component.scss'],
  providers: [],
})
export class ConstellationVideoComponent implements AfterViewInit {
  @Input() youtubeId: string

  //@ViewChild('c11nVideo', { static: false }) videoComponent: VideoComponent
  @ViewChild('simpleDialogContent', { static: false })
  simpleDialogContent: TemplateRef<any>
  dialogTitle: string
  dialogBody: string
  YTPlayer: any
  @ViewChild('videoContainer', { read: ElementRef })
  videoContainerRef: ElementRef = {} as ElementRef

  mediaEvents = {
    playedFromStart: false,
    playedToPosition25: false,
    playedToPosition50: false,
    playedToPosition75: false,
  }
  lastPosition: any = 0
  checkCookie: boolean

  constructor(
    public readonly viewContainer: ViewContainerRef,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit() {
    this.checkCookie = this.getThirdPartyConsent()
  }

  fundVideoList = {
    cMP2BzZ8yIo: {
      title: 'Investing in the future of health care',
      description:
        'Portfolio Manager Jean Hynes describes the fund’s long-term investment approach and the team of experts who help her identify emerging health care trends and opportunities.',
      transcriptTitle: '<span>Investing in the future of health care</span>',
      transcriptBody:
        "<span>So I've been associated with the Vanguard Health Care Fund since the beginning of 1993. I was the biotech and pharmaceutical analyst.  And that first period of time, was really about learning to be a great researcher. Like, how do you figure out where health care is going? How do I figure out where medicine was going and how to connect those to insights. I became a co-portfolio manager in 2008, and then I became the team leader and the sole portfolio manager for the fund.</span><br><br><span>We are researching the whole broad spectrum of health care around the world. And we're trying to create a fund in a portfolio that represents where innovation is happening, how health care is going to be delivered around the world to create great outcomes for the Vanguard owners.</span><br><br><span>The active edge of the Vanguard Health Care Fund is the team. We have many PHDs, MDs that are looking and figuring out where medicine is going. That would be number one. I think number two would be sort of the longevity edge. You take both Vanguard, which evaluates us as portfolio managers on a long-term horizon, and you take the ownership model of Wellington who also evaluates us on a long-term horizon. We are able to capture that longevity piece that part of of the market that most people don't operate in.</span><br><br><span>And then finally, maybe I'll talk a little bit about my own personal edge. So one of the things that I think I do particularly well is connect dots. I love connecting dots over time, connecting dots between small companies and big companies and companies in Japan and companies in Europe and companies in the U.S. to figure out where the health care markets are going.</span><br><br><span>We have a team of 14 global industry analysts that are helping us study the health care industry whether it's biotech or pharmaceutical companies, medical technology companies or health care service companies. And it's the job of our team, this team of 14, to really figure out where medicine is going. How is cancer being treated in 2023 versus where it will be treated in 2030?</span><br><br><span>That's where our team spends our time trying to figure out where the future is going. And if we can get that right, we're going to do really well.</span>",
      duration: '2:34',
      image: 'assets/images/4776_02_MTE_JeanHynes_HealthCareFund_004.jpg',
    },
    IKz6h56DU7I: {
      title: 'Wellington Management Company',
      description:
        "Wellington Management Company CEO Jean Hynes describes how the firm's collaborative culture, private ownership model and global investment resources help set it apart.",
      transcriptTitle: '<span>Wellington Management Company</span>',
      transcriptBody:
        "<span>Wellington has three unique edges that I think help us really serve the Vanguard owners over long periods of time. One would be our culture, the sharing that goes on, the debate that goes on about important topics of innovation, about geopolitics, about what's happening in the world. We all benefit from that ecosystem and that took really decades to build.</span><br><br><span>Culture has been really important since the first day I arrived at Wellington.  And that's about a series of shared values, being very client focused, being very humble, being very focused on excellence.   Those are just to name a few. Second is our ownership model. We're a private partnership and the most interesting thing about the private partnership is that it formed in 1979.  And now it has scaled our size, it's scaled geography and it's also scaled successions. And then finally, I'll talk about our investment ecosystem. We have broad capabilities across equities, fixed income, hedge funds, and the most important part of that is that it's one ecosystem. It's not siloed across asset classes, it's not siloed across geographies.</span><br><br><span>Wellington and Vanguard have a very unique partnership that really goes back to the founding of both companies.  The most interesting thing about the relationship is how we use each other's strengths. So Wellington really focuses on investment content. How do we create equity products, fixed income products for example? And my goal as CEO is to continue to strengthen the relationship between the senior leadership at Vanguard, the portfolio managers and so that we can be successful with Vanguard and Vanguard owners for the next 100 years.</span>",
      duration: '2:00',
      image: 'assets/images/4776_JeanHynes_STILLS_INTVW_002.jpg',
    },
  }

  async ngAfterViewInit() {
    const c11nYTPlayerElementLoaded: any = {}
    c11nYTPlayerElementLoaded.promise = new Promise((resolve, reject) => {
      c11nYTPlayerElementLoaded.resolve = resolve
      c11nYTPlayerElementLoaded.reject = reject
    })

    if (
      this.videoContainerRef.nativeElement.hasAttribute(
        'c11n-web-youtube-player',
      )
    ) {
      c11nYTPlayerElementLoaded.resolve()
    } else {
      const observer = new MutationObserver(() => {
        if (
          this.videoContainerRef.nativeElement.hasAttribute(
            'c11n-web-youtube-player',
          )
        ) {
          c11nYTPlayerElementLoaded.resolve()
          observer.disconnect()
        }
      })
      observer.observe(this.videoContainerRef.nativeElement, {
        attributes: true,
      })
    }

    // wait until the c11n-web-b5-youtube-player bootstraps
    await c11nYTPlayerElementLoaded.promise
    this.videoContainerRef.nativeElement.onReady = (evt: any) => {
      this.YTPlayer = this.videoContainerRef.nativeElement.player
      this.YTPlayer.playVideo()
    }
  }

  // ngAfterViewInit() {
  //   console.log('After view init')
  //   // eslint-disable-next-line complexity, max-statements
  //   // this.videoComponent.playerEvents.asObservable().subscribe((event) => {
  //   //   const percentageComplete = Math.round(
  //   //     (event.data.positionInMilliseconds /
  //   //       event.data.durationInMilliseconds) *
  //   //       ONE_HUNDRED,
  //   //   )
  //   //   switch (event.event) {
  //   //     case 'onPlayheadUpdate':
  //   //       this.lastPosition = event.data.positionInMilliseconds
  //   //       if (
  //   //         event.data.positionInMilliseconds < VIDEO_START &&
  //   //         percentageComplete < TWENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedFromStart']
  //   //       ) {
  //   //         this.mediaEvents['playedFromStart'] = true
  //   //         this.adobeLaunchService.mediaEvent('mediaPlay', this.limelightId)
  //   //       } else if (
  //   //         percentageComplete >= TWENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition25']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition25'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media25PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       } else if (
  //   //         percentageComplete >= FIFTY_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition50']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition50'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media50PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       } else if (
  //   //         percentageComplete >= SEVENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition75']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition75'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media75PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       }
  //   //       break
  //   //     case 'onMediaComplete':
  //   //       this.adobeLaunchService.mediaEvent('mediaComplete', this.limelightId)
  //   //       this.mediaEvents['playedFromStart'] = false
  //   //       this.mediaEvents['playedToPosition25'] = false
  //   //       this.mediaEvents['playedToPosition50'] = false
  //   //       this.mediaEvents['playedToPosition75'] = false
  //   //       break
  //   //   }
  //   // })
  // }

  setDialogInfo(dialogTitle: string) {
    this.dialogTitle = dialogTitle
    this.dialogBody =
      this.dialogTitle === 'Investing in the future of health care' ||
      this.dialogTitle === 'Wellington Management Company'
        ? this.fundVideoList[this.youtubeId].transcriptBody
        : ''

    this.adobeLaunchService.callToAction(
      'Open',
      'Video Transcript Modal',
      'Info',
    )
  }

  addInPlayVideo() {
    this.checkCookie = true
    this.videoContainerRef.nativeElement.displayVideo()
  }

  getThirdPartyConsent(): boolean {
    const optanonCookie = document.cookie
      .split(';')
      .find((cookie) => cookie.trim().startsWith('OptanonConsent='))
    if (optanonCookie) {
      const groupsValues = optanonCookie
        .split('&')
        .find((cookie) => cookie.includes('groups'))
        ?.split('=')[1]
      if (groupsValues) {
        const thirdPartyGroupsConsentValue = decodeURIComponent(groupsValues)
          .split(',')
          .find((key) => key.includes('C0004'))
          ?.split(':')[1]

        const hasConsent = thirdPartyGroupsConsentValue === '1'
        return hasConsent
      }
    }
    return false
  }
}
